export const DetStatus = {
	0: "pending",
	1: "active"
};
